<template>
  <div>
    <v-dialog v-model="dialog" persistent width="50%" :disabled="cloneable">
      <v-btn color="primary" slot="activator" :disabled="cloneable"><v-icon left>content_copy</v-icon> คัดลอกแผนการสอน</v-btn>
      <v-card>
        <v-card-title>
          <span class="subheading teal--text">คัดลอกแผนการสอน</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-select
                  v-bind:items="targetSectionItems"
                  label="กลุ่มที่ต้องการจะคัดลอกแผนการสอน"
                  v-model="target"
                  light
                  item-value="id"
                  item-text="name"
                  no-data-text="ไม่พบข้อมูล"
                  return-object
                  ></v-select>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions> 
          <v-btn class="grey white--text" @click.native="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="blue darken-1 white--text" @click.native="cloneCoursePlan()">คัดลอก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
        v-model="processDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ processTitle }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['dataTableView', 'sectionItems', 'sectionSelected'],
  data: () => ({
    dialog: false,
    target: null,
    processDialog: false,
    processTitle: 'กำลังคัดลอกแผนการสอน...',
  }),
  computed: {
    cloneable () {
      return this.targetSectionItems.length === 0
    },
    targetSectionItems () {
      // console.log('sectionSelected', this.sectionSelected)
      // console.log('sectionItems', this.sectionItems)
      return this.sectionItems.filter(section => section.id !== this.sectionSelected)
    },
  },
  methods: {
    cloneCoursePlan () {
      // console.log('cloneCoursePlan')
      // console.log('src section', this.target)
      // console.log('des section', this.sectionSelected)
      const vm = this
      swal({
        title: 'ยืนยันการคัดลอกแผนการสอน',
        text: "คุณแน่ใจว่าต้องการคัดลอกแผนการสอนจากกลุ่ม " + this.target.name,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) =>  {
        vm.processDialog = true
        if (result.value) {
          const params = {
            target: vm.target.id,
            section: vm.sectionSelected
          }
          vm.$store.dispatch('coursePlan/cloneCoursePlan', params)
            .then((response) => {
              // console.log('response', response)
              const data = {
                dataTableView: vm.dataTableView,
                section: vm.sectionSelected,
                sectionItems: vm.sectionItems
              }
              vm.$emit('reload', data)
              vm.close()
              vm.processDialog = false
            }).catch((error)=>{
              console.log('cloneCoursePlan', error)
              vm.processDialog = false
            })
        } else {
          vm.processDialog = false
        }
      })
    },
    close () {
      this.dialog = false
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/forms/cloneFormDialog.vue